var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown-select area-default"},[_c('div',{staticClass:"my-select",attrs:{"tabindex":"0"}},[_c('div',{staticClass:"select"},[_vm._v("Khu vực")]),_c('div',{staticClass:"dropdown-items",staticStyle:{"display":"none"}})])])
}]

export { render, staticRenderFns }